<div class="card-layout-content">
  <div class="card-layout-content__progress-bar" *ngIf="showProgressBar">
    <p-progressBar mode="indeterminate"></p-progressBar>
  </div>
  <ng-content select="app-card-layout-content-progress-bar"></ng-content>
  <div class="card-layout-content__container p-grid">
    <div class="p-col-12 p-sm-10 p-sm-offset-1">
      <div class="card-layout-content__header"><ng-content select="app-card-layout-content-header"></ng-content></div>
      <ng-content></ng-content>
    </div>
  </div>
</div>
